import { render, staticRenderFns } from "./RolesAndPrivilegesTable.vue?vue&type=template&id=1f937ead&scoped=true"
import script from "./RolesAndPrivilegesTable.vue?vue&type=script&lang=js"
export * from "./RolesAndPrivilegesTable.vue?vue&type=script&lang=js"
import style0 from "./RolesAndPrivilegesTable.vue?vue&type=style&index=0&id=1f937ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f937ead",
  null
  
)

export default component.exports